import React from 'react'

const Hero = () => {
  return (
    <div className='bg-landing-hero h-[100vh] w-full bg-cover bg-center' >
      <div className='h-full flex flex-col gap-y-2 justify-center w-[90%]  md:w-[60%] lg:w-[50%] ml-[5vw] md:ml-[10vw]' >
        <h1 className='text-5xl md:text-7xl font-mosk700 lg:text-6xl text-[#fff] font-mosk600' >Lights Illuminate, Emotions Rise</h1>
        <p className='text-4xl text-[#fff] font-mosk300' >and, the show begins...</p>
        <p className='text-4xl text-[#fff] font-mosk600' >You are the protagonist.</p>
      </div>
    </div>
  )
}

export default Hero
